import React from 'react'

const SVG = ({
  className = '',
  style = {},
  fill = 'currentColor',
  width = '24px',
  height = '24px',
  viewBox = '0 0 24 24'
}) =>
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
  </svg>

export default SVG
